import React, { PropTypes } from 'react'
import { Dialog as ToolboxDialog } from 'react-toolbox/lib/dialog'

const Dialog = ({
  actions, active, children, className, onClose, title,
}) => {
  return (
    <ToolboxDialog
      actions={actions}
      active={active}
      className={className}
      onEscKeyDown={onClose}
      onOverlayClick={onClose}
      title={title}
    >
      {children}
    </ToolboxDialog>
  )
}

Dialog.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
  })),
  active: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
}

Dialog.defaultProps = {
  active: false,
  actions: [],
  children: null,
  className: null,
  title: null,
}

export default Dialog



// WEBPACK FOOTER //
// ./src/components/Dialog/Dialog.js